/*  ========================================================================
    # Hooks - Use URL Params
    ========================================================================  */

import { useState, useEffect } from 'react';

/**
 * Returns all URL parameters and a function to update them.
 */
const useUrlParams = (): {
  params: URLSearchParams;
  setUrlParams: (newParams: { [key: string]: string | number | null }) => void;
} => {
  const [params, setParams] = useState(new URLSearchParams(window.location.search));

  /**
   * Initially remove all empty URL parameters.
   */
  useEffect(() => {
    for (const key of params.keys()) {
      if (params.get(key) === '') params.delete(key);
    }

    if (params.toString()) {
      window.history.replaceState({}, '', `?${params.toString()}`);
    }
  }, []);

  /**
   * Set URL parameters.
   */
  const setUrlParams = (newParams: { [key: string]: string | number | null }) => {
    Object.entries(newParams).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        params.delete(key);
      } else {
        params.set(key, value as string);
      }
    });

    window.history.replaceState({}, '', `?${params.toString()}`);
    setParams(new URLSearchParams(window.location.search));
  };

  return { params, setUrlParams };
};

export default useUrlParams;
